import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=dec1c908&scoped=true&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=dec1c908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec1c908",
  null
  
)

export default component.exports